import React from 'react';
import { formatFullDate } from '../../../helpers/functions';

function ReceiptView(props) {
  return (
    <div id="divToPrint" className='receipt-container'>
      <div style={{ marginLeft: '90px', marginRight: '60px' }}>
        <div style={{ paddingTop: '50px' }}>
          <img src='/img/logo-contract.jpeg' width='160' height='80' className='center-img' />
        </div>
        <div style={{ paddingTop: '40px' }}>
          <p className='contract-title'><b>RECIBO</b></p>
        </div>
        <div style={{ paddingTop: '40px' }}>
          <p className='contract-p-justify'>
            Recebi do (a) Sr. (a) <b>{props.inputs.nome}</b>, inscrita no CPF sob nº {props.inputs.cpf}, 
            com data reservada em {props.inputs.data}. A quantia de {props.inputs.valor} ({props.inputs.valorextenso}),
            referente à {props.inputs.referencia}. Relativo a contratação dos serviços abaixo:
          </p>
        </div>
        <div style={{ paddingTop: '15px', paddingLeft: '10px' }}>
          <p>{props.inputs.servico}</p>
        </div>
        <div style={{ paddingTop: '15px' }}>
          <p className='contract-p-justify'>
            E para maior clareza firmo o presente.
          </p>
        </div>
        <div style={{ paddingTop: '15px' }}>
          <p className='contract-p-justify'>
            RECIFE-PE, {formatFullDate(new Date())}.
          </p>
        </div>
        <div style={{ paddingTop: '45px' }}>
          <img src='/img/sign-contract.jpeg' width='100%' height='100' className='center-img' />
        </div>
        <br className='html2pdf__ignore' />
        <br className='html2pdf__ignore' />
        <br className='html2pdf__ignore' />
        <br className='html2pdf__ignore' />
        <br className='html2pdf__ignore' />
        <br className='html2pdf__ignore' />
        <br className='html2pdf__ignore' />
      </div>
    </div>
  );
}

export default ReceiptView;